// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Base Styles */
.EpisodeCard_container__z11Le {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #111;
    padding: 1rem;
  }
  
  .EpisodeCard_card__jE2MO {
    display: flex;
    max-width: 1200px;
    gap: 4rem;
    background-color: #000;
    padding: 4rem;
    border-radius: 0.75rem;
  }
  
  .EpisodeCard_imageSection__ehZuh {
    flex-shrink: 0;
    width: 400px;
  }
  
  .EpisodeCard_coverImage__VqE8o {
    width: 100%;
    aspect-ratio: 1;
    border-radius: 0.5rem;
    object-fit: cover;
  }
  
  .EpisodeCard_contentSection__khduk {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
  }
  
  .EpisodeCard_title__ClXpN {
    font-size: 2rem;
    font-weight: 700;
    color: white;
    margin-bottom: 0.5rem;
  }
  
  .EpisodeCard_authorInfo__gatyu {
    display: flex;
    gap: 2rem;
    color: #ffffff;
    margin-bottom: 1.5rem;
  }
  
  .EpisodeCard_metadataSection__B-hi3 {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 1rem;
    border-top: 1px solid #fff;
    border-bottom: 1px solid #fff;
    padding: 1.5rem 0;
    margin-bottom: 2rem;
  }
  
  .EpisodeCard_metadataItem__acxk3 {
    display: flex;
    align-items: center;
    gap: 1rem;
    padding-right: 1.5rem;
    border-right: 1px solid #1f2937;
  }
  
  .EpisodeCard_metadataItem__acxk3:last-child,
  .EpisodeCard_metadataItem__acxk3:nth-child(2n) {
    border-right: none;
  }
  
  .EpisodeCard_metadataLabel__W-AHE {
    color: #9ca3af;
  }
  
  .EpisodeCard_metadataValue__deNf7 {
    color: white;
  }
  
  .EpisodeCard_description__SeH0I {
    color: #e5e7eb;
    margin-bottom: 2rem;
    line-height: 1.6;
  }
  
  .EpisodeCard_button__xKPAT {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    background-color: #ef4444;
    color: white;
    padding: 0.75rem 2rem;
    border-radius: 9999px;
    width: fit-content;
    cursor: pointer;
    border: none;
    font-size: 1rem;
    font-weight: 500;
    transition: background-color 0.2s;
  }
  
  .EpisodeCard_button__xKPAT:hover {
    background-color: #dc2626;
  }
  
  /* Media Queries */
  
  /* Large screens & Tablets (max-width: 1024px) */
  @media (max-width: 1024px) {
    .EpisodeCard_card__jE2MO {
      padding: 3rem;
      gap: 3rem;
    }
  
    .EpisodeCard_imageSection__ehZuh {
      width: 350px;
    }
  
    .EpisodeCard_title__ClXpN {
      font-size: 1.75rem;
    }
  
    .EpisodeCard_authorInfo__gatyu {
      gap: 1.5rem;
    }
  }
  
  /* Small tablets & small laptops (max-width: 768px) */
  @media (max-width: 768px) {
    .EpisodeCard_card__jE2MO {
      flex-direction: column;
      gap: 2rem;
      padding: 2rem;
    }
  
    .EpisodeCard_imageSection__ehZuh {
      width: 100%;
    }
  
    .EpisodeCard_metadataSection__B-hi3 {
      grid-template-columns: 1fr;
    }
  
    .EpisodeCard_metadataItem__acxk3 {
      border-right: none;
      border-bottom: 1px solid #1f2937;
      padding-bottom: 1rem;
    }
  
    .EpisodeCard_metadataItem__acxk3:last-child {
      border-bottom: none;
    }
  }
  
  /* Mobile Devices (max-width: 480px) */
  @media (max-width: 480px) {
    .EpisodeCard_card__jE2MO {
      padding: 1rem;
      gap: 1rem;
    }
  
    .EpisodeCard_title__ClXpN {
      font-size: 1.5rem;
    }
  
    .EpisodeCard_authorInfo__gatyu {
      flex-direction: column;
      gap: 1rem;
    }
  
    .EpisodeCard_button__xKPAT {
      padding: 0.5rem 1rem;
      font-size: 0.9rem;
    }
  }
  
  /* Extra Small Devices (max-width: 320px) */
  @media (max-width: 320px) {
    .EpisodeCard_card__jE2MO {
      padding: 0.5rem;
      gap: 0.5rem;
    }
  
    .EpisodeCard_title__ClXpN {
      font-size: 1.25rem;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/AudioPage/components/Css/EpisodeCard.module.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;IACI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,aAAa;EACf;;EAEA;IACE,aAAa;IACb,iBAAiB;IACjB,SAAS;IACT,sBAAsB;IACtB,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,YAAY;EACd;;EAEA;IACE,WAAW;IACX,eAAe;IACf,qBAAqB;IACrB,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,qBAAqB;EACvB;;EAEA;IACE,aAAa;IACb,SAAS;IACT,cAAc;IACd,qBAAqB;EACvB;;EAEA;IACE,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,0BAA0B;IAC1B,6BAA6B;IAC7B,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,qBAAqB;IACrB,+BAA+B;EACjC;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,cAAc;IACd,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,qBAAqB;IACrB,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA,kBAAkB;;EAElB,gDAAgD;EAChD;IACE;MACE,aAAa;MACb,SAAS;IACX;;IAEA;MACE,YAAY;IACd;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,WAAW;IACb;EACF;;EAEA,qDAAqD;EACrD;IACE;MACE,sBAAsB;MACtB,SAAS;MACT,aAAa;IACf;;IAEA;MACE,WAAW;IACb;;IAEA;MACE,0BAA0B;IAC5B;;IAEA;MACE,kBAAkB;MAClB,gCAAgC;MAChC,oBAAoB;IACtB;;IAEA;MACE,mBAAmB;IACrB;EACF;;EAEA,sCAAsC;EACtC;IACE;MACE,aAAa;MACb,SAAS;IACX;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,sBAAsB;MACtB,SAAS;IACX;;IAEA;MACE,oBAAoB;MACpB,iBAAiB;IACnB;EACF;;EAEA,2CAA2C;EAC3C;IACE;MACE,eAAe;MACf,WAAW;IACb;;IAEA;MACE,kBAAkB;IACpB;EACF","sourcesContent":["/* Base Styles */\n.container {\n    min-height: 100vh;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: #111;\n    padding: 1rem;\n  }\n  \n  .card {\n    display: flex;\n    max-width: 1200px;\n    gap: 4rem;\n    background-color: #000;\n    padding: 4rem;\n    border-radius: 0.75rem;\n  }\n  \n  .imageSection {\n    flex-shrink: 0;\n    width: 400px;\n  }\n  \n  .coverImage {\n    width: 100%;\n    aspect-ratio: 1;\n    border-radius: 0.5rem;\n    object-fit: cover;\n  }\n  \n  .contentSection {\n    flex-grow: 1;\n    display: flex;\n    flex-direction: column;\n  }\n  \n  .title {\n    font-size: 2rem;\n    font-weight: 700;\n    color: white;\n    margin-bottom: 0.5rem;\n  }\n  \n  .authorInfo {\n    display: flex;\n    gap: 2rem;\n    color: #ffffff;\n    margin-bottom: 1.5rem;\n  }\n  \n  .metadataSection {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 1rem;\n    border-top: 1px solid #fff;\n    border-bottom: 1px solid #fff;\n    padding: 1.5rem 0;\n    margin-bottom: 2rem;\n  }\n  \n  .metadataItem {\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n    padding-right: 1.5rem;\n    border-right: 1px solid #1f2937;\n  }\n  \n  .metadataItem:last-child,\n  .metadataItem:nth-child(2n) {\n    border-right: none;\n  }\n  \n  .metadataLabel {\n    color: #9ca3af;\n  }\n  \n  .metadataValue {\n    color: white;\n  }\n  \n  .description {\n    color: #e5e7eb;\n    margin-bottom: 2rem;\n    line-height: 1.6;\n  }\n  \n  .button {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n    background-color: #ef4444;\n    color: white;\n    padding: 0.75rem 2rem;\n    border-radius: 9999px;\n    width: fit-content;\n    cursor: pointer;\n    border: none;\n    font-size: 1rem;\n    font-weight: 500;\n    transition: background-color 0.2s;\n  }\n  \n  .button:hover {\n    background-color: #dc2626;\n  }\n  \n  /* Media Queries */\n  \n  /* Large screens & Tablets (max-width: 1024px) */\n  @media (max-width: 1024px) {\n    .card {\n      padding: 3rem;\n      gap: 3rem;\n    }\n  \n    .imageSection {\n      width: 350px;\n    }\n  \n    .title {\n      font-size: 1.75rem;\n    }\n  \n    .authorInfo {\n      gap: 1.5rem;\n    }\n  }\n  \n  /* Small tablets & small laptops (max-width: 768px) */\n  @media (max-width: 768px) {\n    .card {\n      flex-direction: column;\n      gap: 2rem;\n      padding: 2rem;\n    }\n  \n    .imageSection {\n      width: 100%;\n    }\n  \n    .metadataSection {\n      grid-template-columns: 1fr;\n    }\n  \n    .metadataItem {\n      border-right: none;\n      border-bottom: 1px solid #1f2937;\n      padding-bottom: 1rem;\n    }\n  \n    .metadataItem:last-child {\n      border-bottom: none;\n    }\n  }\n  \n  /* Mobile Devices (max-width: 480px) */\n  @media (max-width: 480px) {\n    .card {\n      padding: 1rem;\n      gap: 1rem;\n    }\n  \n    .title {\n      font-size: 1.5rem;\n    }\n  \n    .authorInfo {\n      flex-direction: column;\n      gap: 1rem;\n    }\n  \n    .button {\n      padding: 0.5rem 1rem;\n      font-size: 0.9rem;\n    }\n  }\n  \n  /* Extra Small Devices (max-width: 320px) */\n  @media (max-width: 320px) {\n    .card {\n      padding: 0.5rem;\n      gap: 0.5rem;\n    }\n  \n    .title {\n      font-size: 1.25rem;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `EpisodeCard_container__z11Le`,
	"card": `EpisodeCard_card__jE2MO`,
	"imageSection": `EpisodeCard_imageSection__ehZuh`,
	"coverImage": `EpisodeCard_coverImage__VqE8o`,
	"contentSection": `EpisodeCard_contentSection__khduk`,
	"title": `EpisodeCard_title__ClXpN`,
	"authorInfo": `EpisodeCard_authorInfo__gatyu`,
	"metadataSection": `EpisodeCard_metadataSection__B-hi3`,
	"metadataItem": `EpisodeCard_metadataItem__acxk3`,
	"metadataLabel": `EpisodeCard_metadataLabel__W-AHE`,
	"metadataValue": `EpisodeCard_metadataValue__deNf7`,
	"description": `EpisodeCard_description__SeH0I`,
	"button": `EpisodeCard_button__xKPAT`
};
export default ___CSS_LOADER_EXPORT___;
